module.exports = __webpack_public_path__ + "img/CAR.0c5b796b.png";